export default {
  memberKey: 'rdf:type'

  nameKeys: [
    'PMS_Thing_hasNameByLiteral_xsd'
    'PMS_Property_hasValueByLiteral_xsd'
    'PMS_Milestone_isActualAchievedAtByLiteral_xsd'
    'PMS_Property_hasValueByLiteral_xsd'
    'PMS_PeriodInTime_isDefinedBy_xsd'
  ]

  groupings: []
  queries: []
}
